var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, registerEditorComponent, DEPTHS } from "../ComponentRegistry.js";
import "../types.js";
import { D as DescriptionSchema } from "../../Description-c36d0b9a.js";
import { P as ParentSchema } from "../../Parent-b4f1af10.js";
import { C as ChildSchema } from "../../Child-888ef1d8.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
class ParentSystem {
  constructor() {
    __publicField(this, "type", "Parent");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", ParentSchema);
    __publicField(this, "depth", DEPTHS.LOCOMOTION + 10);
  }
  run(entity, gameModel) {
    var _a, _b;
    const parentData = gameModel.getTypedUnsafe(entity, ParentSchema);
    let modIds;
    for (let i = 0; i < parentData.children.length; i++) {
      const child = parentData.children[i];
      if (!gameModel.isActive(child) || ((_a = gameModel.getTyped(child, ChildSchema)) == null ? void 0 : _a.parent) !== entity) {
        modIds = (modIds == null ? void 0 : modIds.length) ? modIds : gameModel.getComponentIdsByCategory(entity, ComponentCategory.ON_REMOVE_FROM_PARENT);
        for (let i2 = 0; i2 < modIds.length; i2++) {
          const mod = gameModel.getComponent(entity, modIds[i2]);
          if (mod.parent !== void 0) {
            mod.parent = entity;
          }
          if (mod.child !== void 0) {
            mod.child = child;
          }
          const system = gameModel.getSystem(modIds[i2]);
          (_b = system.run) == null ? void 0 : _b.call(system, entity, gameModel);
        }
        parentData.children.splice(i, 1);
        i--;
        continue;
      }
    }
    if (parentData.children.length == 0) {
      gameModel.removeComponent(entity, "Parent");
    }
  }
}
registerSystem(ParentSystem);
registerEditorComponent("Parent", (el, entity, gameModel) => {
  const children = gameModel.getTypedUnsafe(entity, ParentSchema).children;
  const getText = (child) => {
    if (gameModel.hasComponent(child, DescriptionSchema)) {
      const description = gameModel.getTypedUnsafe(child, DescriptionSchema).description;
      return `${child} ${description}`;
    }
    return `${child}`;
  };
  const nextHtml = `
    <h1>Parent</h1>
    <h3>Children</h3>
    <ul>
      ${children.map((child) => `<li data-entity="${child}">${getText(child)}</li>`).join("")}
    </ul>
  `;
  if (el.innerHTML != nextHtml) {
    el.innerHTML = nextHtml;
  }
});
//# sourceMappingURL=Parent.js.map
